module.exports = __webpack_public_path__ + "static/media/privacy_policy.34f63ecd.jpg";